var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('StartupListTopNav'),_vm._v(" "),_c('ScrollTopButton'),_vm._v(" "),_c('div',{staticClass:"mt-6"},[_vm._v("\n    Shortlists go here\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }